import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class Portal extends React.PureComponent {
  constructor(props) {
    super(props);
    const div = document.createElement('div');
    div.style = `
      position: fixed;
      z-index: 999999;
	`;

    document.body.appendChild(div);
    this.ref = div;
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.ref);
  }
}

Portal.propTypes = {
  children: PropTypes.any,
};

export default Portal;
